import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPin: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPin"><Path d="M3.5 20.5L8.5 15.5M11.5 7.5L14.5 2.5L21.5 9.5L16.5 12.5L14 20.5L3.5 10L11.5 7.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPin;
